import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticlesPreview() {
  const latestArticles = articles.slice(0, 6);

  return (
    <section className="w-full py-16 md:py-24 bg-background-50" aria-labelledby="articles-title">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-10 md:mb-14 max-w-6xl mx-auto">
          <div>
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium tracking-wide uppercase mb-4">
              最新洞察
            </span>
            <h2 id="articles-title" className="text-2xl md:text-3xl lg:text-4xl font-bold font-heading text-foreground-950">
              内容创作与营销前沿
            </h2>
          </div>
          <Link
            to="/category/brand-planning"
            className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            查看全部文章
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line" />
            </span>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 max-w-6xl mx-auto">
          {latestArticles.map((article) => (
            <article
              key={article.id}
              className="group flex flex-col bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-300/60 hover:shadow-lg transition-all duration-300"
            >
              <Link to={`/article/${article.id}`} className="relative aspect-[16/10] overflow-hidden flex-shrink-0">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </Link>
              <div className="flex flex-col flex-1 p-5 md:p-6">
                <div className="flex items-center gap-2 mb-3 text-xs text-foreground-500">
                  <span className="px-2 py-0.5 rounded-full bg-primary-50 text-primary-700 font-medium">
                    {article.category}
                  </span>
                  <span>{article.date}</span>
                  <span>·</span>
                  <span>{article.readTime}</span>
                </div>
                <h3 className="text-base font-semibold font-heading text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  <Link to={`/article/${article.id}`}>{article.title}</Link>
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-4 flex-1">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-2 mt-auto">
                  <div className="w-6 h-6 rounded-full bg-primary-100 flex items-center justify-center text-xs text-primary-700 font-medium">
                    {article.author.charAt(0)}
                  </div>
                  <span className="text-xs text-foreground-500">{article.author}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}